@if (isPageAccessToBreadcrumbs) {
  <div class="breadCrumbs">
    <a routerLink="/main">{{ 'HOME' | translate }}</a>
    @for (breadcrumb of breadcrumbs; track breadcrumb) {
      >
      <button
        type="button"
        class="breadcrumb-link"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLinkActive]="'breadcrumbs-active'"
        (click)="routeToPage(breadcrumb.url)">
        {{ breadcrumb.title | translate }}
      </button>
    }
  </div>
}
